import React, { PureComponent } from "react";
import PageLink from "../../../components/Page/PageLink";
import Footer from "../../../components/Footer/Footer";

class Notifications_create extends PureComponent {
  render() {
    return (
      <div className="row" id="notifications_create">
        <div className="col-md-6">
          <div className="contentLight">
            <section>
              <h2>Create Notifications</h2>
              <p>
                To create a notification you need the User ID of the person who
                will see this notification, the “title” the “description” and
                the “link“. Icon and icon colours are optional. The notification
                icon must be an icon supported by the material icon font
                produced by Google. For a full list of icons supported look
                under the interface section. colours are any 6 hexadecimal
                character colour prefix by hash from a stylistic point of view
                we recommend using colours chosen from the material design
                colour scheme also produced by Google. references and examples
                of the material design colour scheme can be found in the
                interface section of this website.
              </p>
              <Footer
                section={this.props.section}
                article={this.props.article}
                routeParams={this.props.routeParams}
              />
            </section>
          </div>
        </div>
        <div className="col-md-6 darkCol">
          <div className="contentDark">
            <section>
              <h2>Create Notification Example</h2>
              <p>This example creates a simple notification.</p>
              <p>Request:</p>
              <div className="darkCode">
                <span className="methodCodePOST">POST</span> - https://
                <span className="jsonY">example</span>
                .api.nexoid.com/v1/notification
                <div>
                  <br />
                </div>
                <div>Body:</div>
                <div>&#123;</div>
                <div className="i1">
                  <span className="jsonG">"session_id"</span>:{" "}
                  <span className="jsonY">
                    "
                    <span className="jsonO">
                      &#123;&#123;session_id&#125;&#125;
                    </span>
                    "
                  </span>
                  ,
                </div>
                <div className="i1">
                  <span className="jsonG">"notification"</span>: &#123;
                </div>
                <div className="i2">
                  <span className="jsonG">"user_id"</span>:{" "}
                  <span className="jsonY">"12"</span>,
                </div>
                <div className="i2">
                  <span className="jsonG">"title"</span>:{" "}
                  <span className="jsonY">"INC-75 was assigned to you"</span>,
                </div>
                <div className="i2">
                  <span className="jsonG">"description"</span>:{" "}
                  <span className="jsonY">
                    "Sally Peterson assigned you a ticket."
                  </span>
                  ,
                </div>
                <div className="i2">
                  <span className="jsonG">"link"</span>:{" "}
                  <span className="jsonY">"record/incident/INC-75"</span>,
                </div>
                <div className="i2">
                  <span className="jsonG">"icon"</span>:{" "}
                  <span className="jsonY">"headset_mic"</span>,
                </div>
                <div className="i2">
                  <span className="jsonG">"icon_color"</span>:{" "}
                  <span className="jsonY">"#FFD54F"</span>,
                </div>
                <div className="i2">
                  <span className="jsonG">"icon_color_background"</span>:{" "}
                  <span className="jsonY">"#1976D2"</span>
                </div>
                <div className="i1">&#125;</div>
                <div>&#125;</div>
              </div>
              <p>Response:</p>
              <div className="darkCode">
                <div>
                  Code: <span className="statusCode">200</span>
                </div>
                <div>
                  <br />
                </div>
                <div>Body:</div>
                <div>&#123;</div>
                <div className="i1">
                  <span className="jsonG">"id"</span>:{" "}
                  <span className="jsonY">"39"</span>,
                </div>
                <div className="i1">
                  <span className="jsonG">"notification"</span>: &#123;
                </div>
                <div className="i2">
                  <span className="jsonG">"user_id"</span>:{" "}
                  <span className="jsonY">"12"</span>,
                </div>
                <div className="i2">
                  <span className="jsonG">"title"</span>:{" "}
                  <span className="jsonY">"INC-75 was assigned to you"</span>,
                </div>
                <div className="i2">
                  <span className="jsonG">"description"</span>:{" "}
                  <span className="jsonY">
                    "Sally Peterson assigned you a ticket."
                  </span>
                  ,
                </div>
                <div className="i2">
                  <span className="jsonG">"link"</span>:{" "}
                  <span className="jsonY">"record/incident/INC-75"</span>,
                </div>
                <div className="i2">
                  <span className="jsonG">"icon"</span>:{" "}
                  <span className="jsonY">"headset_mic"</span>,
                </div>
                <div className="i2">
                  <span className="jsonG">"icon_color"</span>:{" "}
                  <span className="jsonY">"#FFD54F"</span>,
                </div>
                <div className="i2">
                  <span className="jsonG">"icon_color_background"</span>:{" "}
                  <span className="jsonY">"#1976D2",</span>
                </div>
                <div className="i2">
                  <span className="jsonG">"created"</span>:{" "}
                  <span className="jsonY">"2016-07-18T21:50:34.094Z"</span>,
                </div>
                <div className="i2">
                  <span className="jsonG">"updated"</span>:{" "}
                  <span className="jsonY">"2016-07-18T21:50:34.094Z"</span>
                </div>
                <div className="i1">&#125;</div>
                <div>&#125;</div>
              </div>
            </section>
          </div>
        </div>
      </div>
    );
  }
}

export default Notifications_create;



// WEBPACK FOOTER //
// ./src/components/knowlege/api/Notifications_create.js